export default __webpack_public_path__ + "static/media/spec.19fdcb86.svg";